import { UserDetailsCardVariant } from "apps/studio/src/Components/UserDetailsCard/UserDetailsCard";

import { Conversation, UserInterface, UserVarsMap } from "@swivl-mono/types";
import { InsetTabsComponent } from "@swivl-mono/ui";

import { useUrlState } from "../../../../Hooks/useUrlState";
import "./UserDetails.scss";
import { UserDetailsCustomerDetailsView } from "./View/UserDetails.CustomerDetails.View";
import { UserDetailsLocationLookupView } from "./View/UserDetails.LocationLookupView";
import { UserDetailsNotesView } from "./View/UserDetails.Notes.View";
import { UserDetailsRecordingsView } from "./View/UserDetails.Recordings.View";

export enum UserDetailsTabID {
  Details = "details",
  Inventory = "inventory",
  Activity = "activity",
  Tickets = "tickets",
  Notes = "notes",
  Recordings = "recordings"
}

export interface UserDetailsTab {
  id: UserDetailsTabID;
  label: string;
  badge: boolean;
}

interface Props {
  user: UserInterface;
  userVars: UserVarsMap | undefined;
  conversation?: Conversation;
  tabs: UserDetailsTab[];
  userCardVariant?: UserDetailsCardVariant;
}

export default function UserDetails({ user, userVars, tabs, userCardVariant }: Props) {
  const { searchParams, setSearchParam } = useUrlState();
  const availableTabIds = tabs.map((tab) => tab.id);
  const defaultTab = tabs[0]?.id ?? UserDetailsTabID.Details;
  const paramTab = searchParams.get("detailsTab") as UserDetailsTabID | null;
  const selectedTab = paramTab && availableTabIds.includes(paramTab) ? paramTab : defaultTab;

  return (
    <div className="flex h-full flex-col overflow-y-auto bg-grey-50">
      <div className="sticky top-0 z-20 bg-grey-50 px-3">
        <InsetTabsComponent items={tabs} selectedItem={selectedTab} itemSelected={(id) => setSearchParam("detailsTab", id as UserDetailsTabID)} />
      </div>
      <div className="UserDetailsContainer flex flex-1 flex-col gap-3 px-3 pt-3 pb-9">
        {selectedTab === UserDetailsTabID.Details && (
          <UserDetailsCustomerDetailsView user={user} userVars={userVars} userCardVariant={userCardVariant} />
        )}
        {selectedTab === UserDetailsTabID.Inventory && <UserDetailsLocationLookupView user={user} userVars={userVars} />}
        {selectedTab === UserDetailsTabID.Notes && <UserDetailsNotesView user={user} />}
        {selectedTab === UserDetailsTabID.Recordings && <UserDetailsRecordingsView user={user} />}
      </div>
    </div>
  );
}
